import { css, cx } from '@emotion/css';
import React, { PureComponent } from 'react';

const navbar = css`
  clear: both;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 0;
  border: none;
  padding: 0 20px;
`;
export default class DocsHeader extends PureComponent {
  render() {
    return (
      <div>
        <nav
          className={cx(
            css`
              background: #fff;
              border-bottom: 1px solid #e1e6eb;
              min-height: 50px;
              justify-content: space-between;
              box-shadow: none;
              margin-bottom: 0;
            `,
            navbar,
          )}
        >
          <div
            className={css`
              margin-left: 0px;
              text-decoration: none;
              margin-right: auto;
              padding: 0;
              height: auto;
            `}
          >
            <img src="https://static.ux.cimpress.io/mcp-ux-css/1.2/release/assets/logo-dark.svg" alt="Cimpress" />
          </div>
        </nav>
        <div className="navbar-fluid ">
          <nav
            className={cx(
              css`
                background-color: #fff;
                min-height: 50px;
                padding: 0 20px;
                box-shadow: 0 2px 4px 0 rgba(105, 117, 130, 0.16), 0 2px 4px 0 rgba(105, 117, 130, 0.23);
                position: relative;
                margin-bottom: 8px;
                border: 1px solid transparent;
              `,
              navbar,
            )}
          >
            <div className="navbar-header">
              <h2
                className={css`
                  margin: 0;
                `}
              >
                @cimpress/react-components demo page
              </h2>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}
